import { getDatabase } from './db';
import { RxDBUpdatePlugin } from 'rxdb/plugins/update';
import { addRxPlugin } from 'rxdb';
import { prioritizePasswordLoginAccount } from '@/services/passwordLogin';

addRxPlugin(RxDBUpdatePlugin);

export async function addAccount(account) {
    try {
        const db = await getDatabase();

        await db.accounts.insert(account);
    } catch (error) {
        console.error('Failed to add account:', error.code || error.name);
    }
}

export async function getAccounts() {
    const db = await getDatabase();
    if (!db.accounts) {
        return [];
    }
    return prioritizePasswordLoginAccount(await db.accounts.find().exec());
}

export async function getAccountByLogin(login) {
    const db = await getDatabase();
    if (!db.accounts) {
        return null;
    }
    return db.accounts.findOne({ selector: { login } }).exec();
}

export async function updateAccount(login, updatedData) {
    const db = await getDatabase();
    const account = await db.accounts.findOne({ selector: { login } }).exec();
    if (account) {
        await account.update({ $set: updatedData });
    }
}

export async function deleteAccount(login) {
    const db = await getDatabase();
    const account = await db.accounts.findOne({ selector: { login } }).exec();

    if (account) {
        await account.remove();
    }
}

export async function dropAllAccounts() {
    const db = await getDatabase();
    await db.remove();
}
